module.exports = __webpack_public_path__ + "img/skype.d778590d.svg";